import { gql } from "@apollo/client";

export default gql`
  mutation RelinkMergeDevIntegration($integrationId: Int!) {
    relinkMergeDevIntegration(integrationId: $integrationId) {
      success
      linkToken
      integrationName
      endUserOriginId
      error
    }
  }
`;
